import request from '@/utils/request'

export function leadSummary(params) {
  return request({
    url: '/api/report/lead-summary',
    method: 'get',
    params
  })
}

export function projectProfitReport(params) {
  return request({
    url: '/api/report/project-profit',
    method: 'get',
    params
  })
}

export function projectDashboard(projectId) {
  return request({
    url: `/api/report/project/${projectId}/dashboard`,
    method: 'get'
  })
}

export function reportOverview(params) {
  return request({
    url: '/api/report/overview',
    method: 'get',
    params
  })
}
